import OneTapsTrackingPlugin from '@d-shared/plugins/one-taps-tracking/one-taps-tracking';

export default [
  OneTapsTrackingPlugin,
];
